export function SyncProgress({ job, socket }) {
  const progress = job.totalEmails > 0 ? Math.round((job.fetchedEmails / job.totalEmails) * 100) : 0

  return (
    <div className={`sync-progress sync-${job.status}`}>
      <div className="progress-header">
        <span className="progress-status">{job.status}</span>
        <span className="progress-percent">{progress}%</span>
      </div>

      <div className="progress-bar">
        <div
          className="progress-bar-fill"
          style={{ width: `${progress}%` }}
        />
      </div>

      <div className="progress-stats">
        <span>Total: {job.totalEmails.toLocaleString()}</span>
        <span>Fetched: {job.fetchedEmails.toLocaleString()}</span>
        <span>Inserted: {job.insertedEmails.toLocaleString()}</span>
      </div>
    </div>
  )
}
